import { useState, useEffect } from "react";
import { subscribeToMaintenanceConfig } from "@/services/firebase-adapter";

function getInitialMaintenanceMode(): boolean {
  if (
    typeof window !== "undefined" &&
    (window as Window & { Cypress?: unknown }).Cypress
  ) {
    try {
      const testToggles = JSON.parse(
        window.localStorage.getItem("__cypress.featureToggles") || "{}"
      );
      if (typeof testToggles["ENABLE_MAINTENANCE_MODE"] === "boolean") {
        return testToggles["ENABLE_MAINTENANCE_MODE"];
      }
    } catch {
      // ignore
    }
  }
  return false;
}

export default function useMaintenanceConfig() {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(
    getInitialMaintenanceMode
  );

  useEffect(() => {
    const unsubscribe = subscribeToMaintenanceConfig(setIsMaintenanceMode);
    return unsubscribe;
  }, []);

  return { isMaintenanceMode };
}
